import { Icon, IconName } from "@/components/ui/Icon";
import { Switch } from "@/components/ui/switch";

import { UserConsentItem } from "@/models/site-credentials/consents/UserAppConsents";

/** consentName vem do backend (ClientProps). Cai no envelope quando desconhecido. */
const ICON_BY_CONSENT_NAME: Record<string, IconName> = {
  loyalty_ccv_number: "StreamlineFinanceCreditCardRegular",
  username_phone_number: "StreamlineDevicesMobilePhoneRegular",
  username_email: "StreamlineEmailsEnvelopeRegular",
};

type ConsentDataRowProps = {
  item: UserConsentItem;
  checked: boolean;
  disabled?: boolean;
  onToggle: (id: string) => void;
};

export default function ConsentDataRow({ item, checked, disabled, onToggle }: ConsentDataRowProps) {
  const iconName = ICON_BY_CONSENT_NAME[item.consentName ?? ""] ?? "StreamlineEmailsEnvelopeRegular";

  return (
    <div className="flex items-center justify-between gap-8">
      <div className="flex min-w-0 items-center gap-8">
        <span className="flex size-16 shrink-0 items-center justify-center rounded-md bg-[var(--surface-default-variant)]">
          <Icon name={iconName} size="sm" className="text-[var(--on-surface-variant)]" />
        </span>
        <div className="flex min-w-0 flex-col">
          <span className="text-sm text-[var(--on-surface-variant)]">{item.displayText}</span>
          {item.maskedValue && (
            <span className="truncate text-sm font-bold text-[var(--on-surface-default)]">
              {item.maskedValue}
            </span>
          )}
        </div>
      </div>
      {!item.isMandatory && (
        <Switch
          checked={checked}
          disabled={disabled}
          onCheckedChange={() => onToggle(item.id)}
          aria-label={item.displayText}
        />
      )}
    </div>
  );
}
